import { __assign, __rest } from "tslib";
import { useContext, useCallback, useRef, useEffect } from 'react';
import biLogger from '../BiLogger.logger';
import { BiContext } from '../BiLogger.context';
import { SessionContext, } from '@wix/da-react-context/pkg/SessionContext';
import { BiContextProvidedValue, } from '../events/context';
var defaultContextFields = ['view', 'component', 'notification_message_id'];
var ignoredFields = [
    '_biLoggerVersion',
    '_rankOffset',
    '_rankIndex',
    '_value',
];
function isV2Event(eventData) {
    return eventData._biLoggerVersion === 2;
}
function mergeEventDataWithContext(eventData, context) {
    var mergedBiData = {
        evid: eventData.evid,
    };
    // fill up the context stuff we always grab by default
    defaultContextFields.forEach(function (key) {
        if (context[key]) {
            mergedBiData[key] = context[key];
        }
    });
    // now add the data from the event itself, filling in anything that is supposed to come from context
    Object.keys(eventData).forEach(function (key) {
        var _a;
        // ignore internal use only fields
        if (ignoredFields.includes(key)) {
            return;
        }
        // pull values from context
        if (eventData[key] === BiContextProvidedValue) {
            // rank calculation
            if (key === 'rank') {
                var _rankIndex = (_a = eventData._rankIndex) !== null && _a !== void 0 ? _a : context._rankIndex;
                var _rankOffset = context._rankOffset;
                if (typeof _rankOffset !== 'undefined' &&
                    typeof _rankIndex !== 'undefined') {
                    mergedBiData[key] = _rankOffset + _rankIndex;
                    return;
                }
            }
            if (context[key]) {
                mergedBiData[key] = context[key];
            }
            return;
        }
        mergedBiData[key] = eventData[key];
    });
    return mergedBiData;
}
export function useBiLogger() {
    var biContext = useContext(BiContext);
    var publicSession = useContext(SessionContext);
    // The following is outright cheating the memoization system, but we want
    // to make sure logEvent is a single, stable instance. So instead of forcing
    // it to recreate the callback every time the contexts update to keep the
    // closure from going stale, we keep non-rerendering refs that provide the
    // latest values for it.
    var contextMemoForOptimization = useRef(biContext);
    var sessionMemoForOptimization = useRef(publicSession);
    useEffect(function () {
        contextMemoForOptimization.current = biContext;
        sessionMemoForOptimization.current = publicSession;
    }, [biContext, publicSession]);
    var logEvent = useCallback(function (eventData) {
        if (isV2Event(eventData)) {
            return biLogger.log(sessionMemoForOptimization.current, mergeEventDataWithContext(eventData, contextMemoForOptimization.current), false);
        }
        var mergedData = __assign(__assign({}, contextMemoForOptimization.current), eventData);
        var _rankIndex = mergedData._rankIndex, _rankOffset = mergedData._rankOffset, href = mergedData.href, biData = __rest(mergedData, ["_rankIndex", "_rankOffset", "href"]);
        if (typeof _rankOffset !== 'undefined' &&
            typeof _rankIndex !== 'undefined') {
            biData.rank = _rankOffset + _rankIndex;
        }
        return biLogger.log(sessionMemoForOptimization.current, biData);
    }, []);
    return logEvent;
}
//# sourceMappingURL=useBiLogger.js.map